const ChosingUsData = {
  title: "WHY CHOOSE US AS YOUR DISABILITY",
  title2: "SERVICE PROVIDER?",
  description: `As a Sydney-based registered NDIS disability service provider, we bring over 20 years of expertise in supporting individuals with disabilities. Our primary focus is to empower people with disabilities to live as independently as possible. With our extensive experience, we are dedicated to providing the highest level of support and helping our clients achieve their goals.`,
};

export default ChosingUsData;
